import {
  ApolloClient,
  ApolloProvider,
  concat,
  defaultDataIdFromObject,
  HttpLink,
  InMemoryCache,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { ReactNode } from 'react';
import { EnvironmentConfig } from '../environment-config';

interface GraphQLProviderProps {
  children: ReactNode;
}

const createApolloClient = () => {
  const httpLink = new HttpLink({
    uri: EnvironmentConfig.apiUrl,
  });

  return new ApolloClient({
    cache: new InMemoryCache({
      dataIdFromObject: (object) => {
        // eslint-disable-next-line no-underscore-dangle
        switch (object.__typename) {
          case 'ExpertTagType':
            return Math.random().toString();
          default:
            return defaultDataIdFromObject(object);
        }
      },
    }),
    link: concat(
      setContext(async (context) => ({
        ...context,
        headers: {
          'target-service': 'hub-api',
        },
      })),
      httpLink,
    ),
  });
};

export const GraphQLProvider = ({ children }: GraphQLProviderProps) => {
  return <ApolloProvider client={createApolloClient()}>{children}</ApolloProvider>;
};
